import React, { useState, useEffect } from "react";
import { Button, Collapse } from "reactstrap";
import classnames from "classnames";
import Loader from "../../../components/Loader";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { Utils } from "helpers/utils";
import AppSimpleBar from "components/AppSimpleBar";
import { UserTypes } from "api";
import {
  erpGetCustomerTask,
  erpGetPrevTopNoVolume,
  erpCateSizeNotSaleMoreThan45,
  erpCateInterestNotSale,
  erpCateNotSaleMoreThan60,
} from "../../../redux/actions";

interface ErpTopicProps {
  isLoading: boolean;
  children: any;
  bxIcon: string;
  title: string;
  // count?: number; // Optional prop
}
const ErpTopic = ({
  isLoading,
  children,
  bxIcon,
  title,
  // count,
}: ErpTopicProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <div className="accordion-item">
      <div className="accordion-header" >
        <Button color="none" className={classnames(
          "accordion-button",
          "font-size-16",
          "fw-medium", "text-primary",
          { collapsed: !isOpen }
        )}
          onClick={() => setIsOpen((prev) => !prev)}
          type="button"
        >
          {/* <i className={classnames("", "me-1", bxIcon)}></i> */}
          {""}{title}
        </Button>
      </div>

      <Collapse isOpen={isOpen} className="accordion-collapse">
        <div className="accordion-body position-relative pl-4 pb-1 " style={{ paddingTop: "0px", fontSize: "0.95em" }}>
          {isLoading && (<Loader />)}
          {children}
        </div>
      </Collapse>
    </div>
  );
};

interface ErpTopicsProps {
  display: boolean;
  customerId: number;
  groupType: UserTypes;
}
const ErpTopics = ({ display, customerId, groupType }: ErpTopicsProps) => {
  const { dispatch, useAppSelector } = useRedux();

  useEffect(() => {
    if (display && customerId > 0) {
      dispatch(erpGetCustomerTask(customerId));
      dispatch(erpGetPrevTopNoVolume(customerId));
      dispatch(erpCateSizeNotSaleMoreThan45(customerId));
      dispatch(erpCateInterestNotSale(customerId));
      dispatch(erpCateNotSaleMoreThan60(customerId));
    }
  }, [display, customerId]);

  // console.log('ErpTopics userType = ' + userType);
  const storeData = createSelector(
    (state: any) => state.Chats,
    (state) => ({
      erpGetCustomerTaskLoading: state.erpGetCustomerTaskLoading,
      erpGetCustomerTasks: state.erpGetCustomerTasks,

      erpGetPrevTopNoVolumeLoading: state.erpGetPrevTopNoVolumeLoading,
      erpGetPrevTopNoVolumes: state.erpGetPrevTopNoVolumes,

      erpCateSizeNotSaleMoreThan45Loading: state.erpCateSizeNotSaleMoreThan45Loading,
      erpCateSizeNotSaleMoreThan45s: state.erpCateSizeNotSaleMoreThan45s,

      erpCateInterestNotSaleLoading: state.erpCateInterestNotSaleLoading,
      erpCateInterestNotSales: state.erpCateInterestNotSales,

      erpCateNotSaleMoreThan60Loading: state.erpCateNotSaleMoreThan60Loading,
      erpCateNotSaleMoreThan60s: state.erpCateNotSaleMoreThan60s,
    })
  );
  // Inside your component
  const {
    erpGetCustomerTaskLoading, erpGetCustomerTasks,
    erpGetPrevTopNoVolumeLoading, erpGetPrevTopNoVolumes,
    erpCateSizeNotSaleMoreThan45Loading, erpCateSizeNotSaleMoreThan45s,
    erpCateInterestNotSaleLoading, erpCateInterestNotSales,
    erpCateNotSaleMoreThan60Loading, erpCateNotSaleMoreThan60s
  } = useAppSelector(storeData);

  const activeTabErp = display;
  const onTaskClick = async (custPlanID: number) => {
    try {
      const url = `https://erp.2smetal.com/customer/commenttask/${customerId}/${custPlanID}?menu=0`;
      // console.log({ customerId, custPlanID, url });
      Utils.OpenUrlInSameTab(url, "erp_task");
      // const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', chatUserDetails.companyId);
      // openUrlInSameTab(erpUrl);
      // alert(customerId);
      // alert('ok');
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }
  return (
    <AppSimpleBar className="erp-topics-container">
      <div className="accordion accordion-flush" style={{ display: activeTabErp ? "" : "none" }}>
        {/* งานที่ต้องทำ */}
        {groupType == UserTypes.Group &&
          <ErpTopic isLoading={erpGetCustomerTaskLoading} bxIcon="bx bx-task" title="☑️ งานที่ต้องทำ">
            {(erpGetCustomerTasks ?? []).length <= 0
              ? (<div className="text-center"><i>-- ไม่มีข้อมูล --</i></div>)
              : (
                <ul className="list-unstyled">
                  {erpGetCustomerTasks.map((ee: any, key: number) => (
                    <li key={key} className="pb-2" onClick={() => onTaskClick(ee.custPlanID)}>
                      <div className="d-flex align-items-center hover">
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="text-truncate mb-0 hand" onClick={(e) => Utils.ToggleClass(e.currentTarget, "text-truncate")}>{key + 1}. {ee.custPlanTitle}</p>
                        </div>
                        {ee.custPlanDate && (
                          <div className="ms-auto">
                            <span className="badge badge-soft-primary text-danger rounded p-1 ml-1 fw-normal">
                              {Utils.GetDMY(ee.custPlanDate)}
                            </span>
                          </div>
                        )}
                      </div>

                    </li>
                  ))}
                </ul>
              )}
          </ErpTopic>
        }

        {/* TOP 20 ไม่ซื้อเกิน 30 วัน */}
        {groupType == UserTypes.Group &&
          <ErpTopic isLoading={erpGetPrevTopNoVolumeLoading} bxIcon="bx bx-line-chart-down" title="📉 TOP 20 ยังไม่ซื้อเกิน 30 วัน">
            {(erpGetPrevTopNoVolumes ?? []).length <= 0
              ? (<div className="text-center"><i>-- ไม่มีข้อมูล --</i></div>)
              : (
                // version 1 UL list
                <AppSimpleBar style={{ maxHeight: "200px" }}>
                  <ul className="list-unstyled">
                    {erpGetPrevTopNoVolumes.map((ee: any, key: number) => (
                      <li key={key} className="pb-1 line-divider-bottom">
                        <div className="hover">
                          <div className="text-left">{key + 1}. {ee.productName}</div>
                          <div className="d-flex justify-content-between fz-08 ps-3">
                            <span className="text-danger">{ee.tonsLastYear} ตัน</span>
                            <span className="text-danger">{ee.lastOrderDay} วัน</span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </AppSimpleBar>
              )}
          </ErpTopic>
        }

        {/* หมวดอยากขาย แต่ยังไม่มียอด */}
        {groupType == UserTypes.Group &&
          <ErpTopic isLoading={erpCateSizeNotSaleMoreThan45Loading} bxIcon="bx bx-bell-minus" title="🔖 หมวดอยากขาย ไม่มียอด > 45 วัน">
            {(erpCateSizeNotSaleMoreThan45s ?? []).length <= 0
              ? (<div className="text-center"><i>-- ไม่มีข้อมูล --</i></div>)
              : (
                // version 1 UL list
                <AppSimpleBar style={{ maxHeight: "200px" }}>
                  <ul className="list-unstyled">
                    {erpCateSizeNotSaleMoreThan45s.map((ee: any, key: number) => (
                      <li key={key} className="pb-1 line-divider-bottom">
                        <div className="hover">
                          <div className="text-left">{ee.productCategoryName}</div>
                          <div className="fz-09">
                            {(ee.prosizeGroup.split('<|>').map((item: any, key2: number) => (
                              <span key={key2} className="erp-tag no-wrap">{item}</span>
                            )))}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </AppSimpleBar>
              )}
          </ErpTopic>
        }

        {/* หมวดที่สนใจ ไม่เคยซื้อ */}
        {groupType == UserTypes.Group &&
          <ErpTopic isLoading={erpCateInterestNotSaleLoading} bxIcon="bx bx-line-chart-down" title="📌 หมวดที่สนใจ ไม่เคยซื้อ">
            {(erpCateInterestNotSales ?? []).length <= 0
              ? (<div className="text-center"><i>-- ไม่มีข้อมูล --</i></div>)
              : (
                <AppSimpleBar style={{ maxHeight: "200px" }}>
                  {erpCateInterestNotSales.map((ee: any, key: number) => (
                    <span key={key} className="erp-tag no-wrap">{ee.productCategoryName}</span>
                  ))}
                </AppSimpleBar>
              )}
          </ErpTopic>
        }

        {/* เคยซื้อ ไม่ขาย > 60 วัน */}
        {groupType == UserTypes.Group &&
          <ErpTopic isLoading={erpCateNotSaleMoreThan60Loading} bxIcon="bx bx-line-chart-down" title="🔎 เคยซื้อ ไม่มียอด > 60 วัน">
            {(erpCateNotSaleMoreThan60s ?? []).length <= 0
              ? (<div className="text-center"><i>-- ไม่มีข้อมูล --</i></div>)
              : (
                <>
                  {erpCateNotSaleMoreThan60s.map((ee: any, key: number) => (
                    <span key={key} className="erp-tag">{ee.productCategoryName}</span>
                  ))}
                </>
              )}
          </ErpTopic>
        }

      </div>
    </AppSimpleBar>
  )
}

export default ErpTopics;
